// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1rrKz","inputDescription":"styles_inputDescription__3Jum8"};